import i18n from "app/config/i18n";
import { useEffect } from "react";

// Custom hook for language change
const useAppLanguage = (locale: string) => {
    useEffect(() => {
        i18n.changeLanguage(locale);
    }, [locale]);
};

export { useAppLanguage };